import React from "react";
import { BananJobCard } from "./BananJobCard";
import type { BananJobResult } from "./BananJobCard";
import { KlingJobCard } from "./KlingJobCard";
import type { KlingJobResult } from "./KlingJobCard";

// Thin wrappers around the primary job cards. The previous side-by-side
// parallel-leg experiment has been removed; these are kept as named exports so
// existing callsites continue to compile without touching their JSX.

interface ImageJobProps {
  primary: { jobId: string; itemCount?: number };
  onComplete?: (jobId: string, result: BananJobResult) => void;
}

export function ImageSideBySide({ primary, onComplete }: ImageJobProps) {
  return <BananJobCard jobId={primary.jobId} itemCount={primary.itemCount} onComplete={onComplete} />;
}

interface VideoJobProps {
  primary: { jobId: string; itemCount?: number };
  onComplete?: (jobId: string, result: KlingJobResult) => void;
}

export function VideoSideBySide({ primary, onComplete }: VideoJobProps) {
  return <KlingJobCard jobId={primary.jobId} itemCount={primary.itemCount} onComplete={onComplete} />;
}
